<script>
    import * as ze from "@axel669/zephyr"

    import NewItem from "./new-item.svelte"
    import ItemEdit from "./item-edit.svelte"

    const {
        bag = $bindable()
    } = $props()

    const bgs = [
        "@background-element",
        "transparent",
    ]

    const remove = (item) => {
        if (item === null) {
            return
        }
        // console.log("remove", item)
        bag.items = bag.items.filter(
            bagItem => bagItem !== item
        )
    }
</script>

<ze.Grid cols="40px 32px 1fr 64px" p="0px">
    {#each bag.items as item, index}
        <ze.Grid cols="subgrid" p="0px" bg.c={bgs[index % 2]} col="span 4" gr.rows="44px">
            <ze.EntryButton compact color="@secondary" onentry={remove}>
                <ze.Icon name="info-hexagon" t.sz="24px" />
                {#snippet modal()}
                    <ItemEdit bind:item={bag.items[index]} {bag} />
                {/snippet}
            </ze.EntryButton>
            <ze.Text disp="flex" fl.cross="center">
                {item.count}x
            </ze.Text>
            <ze.Text disp="flex" fl.cross="center">
                {item.name}
            </ze.Text>
            <ze.Text disp="flex" fl.cross="center">
                {(item.weight * item.count).toFixed(1)}lbs
            </ze.Text>
        </ze.Grid>
    {:else}
        <ze.Text col="span 4">No items in the bag</ze.Text>
    {/each}
</ze.Grid>
